import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { ShortcutService } from '../shortcut.service';

@Component({
  selector: 'app-champion-search',
  templateUrl: './champion-search.component.html',
  styleUrls: ['./champion-search.component.scss']
})
export class ChampionSearchComponent implements OnInit {

  private textInput: string;
  private data: {};



  constructor(
    private dataService: DataService,
    private shortcutService: ShortcutService
  ) { }



  ngOnInit() { }

  ngAfterViewInit() { }



  updateSearch($event: any) {
    this.data = this.dataService.getChampionData();
    this.textInput = (<HTMLInputElement>document.getElementById("championSearchInput")).value;
    // remove all whitespaces from string
    var input = this.textInput.replace(/\s/g,'').toLowerCase();
    // List of all champions that match the input
    var result = [];
    // Perform the search only if there is text in the search bar
    if (input.length > 0) {
      var characters = input.split("");
      for (let championKey in this.data) {
        let champion = this.data[championKey];
        let name = champion['name'].replace('IV','IV4').toLowerCase();
        let iteratorInString = 0;
        let match = true;
        for (var i = 0; i < characters.length; i++) {
          if (!(name.indexOf(characters[i], iteratorInString) >= iteratorInString))
            match = false;
          else
            iteratorInString = name.indexOf(characters[i], iteratorInString)+1;
        }
        if (match)
          result.push(champion);
      }
      var allChampionPoolItems = document.getElementsByTagName("app-champion-list-member");
      for (let i = 0; i < allChampionPoolItems.length; i++) {
        (<HTMLElement>allChampionPoolItems[i]).style.display = "none";
      }
      for (let i = 0; i < result.length; i++) {
        document.getElementById(result[i]['id']+"ChampionListMember").parentElement.style.display = "block"
      }
    }
    else {
      var allChampionPoolItems = document.getElementsByTagName("app-champion-list-member");
      for (let i = 0; i < allChampionPoolItems.length; i++) {
        (<HTMLElement>allChampionPoolItems[i]).style.display = "block";
      }
    }
  }

  handleOnFocus() {
    this.shortcutService.enabled = false;
  }

  handleOnBlur() {
    this.shortcutService.enabled = true;
    console.log(this.shortcutService.enabled)
  }

}
